/* 🤖 this file was generated by svg-to-ts */
export const matIconAirplanemodeInactive: {
  name: 'airplanemode-inactive';
  data: string;
} = {
  name: 'airplanemode-inactive',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M10.5 7.67V3.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V9l8.5 5v2l-4.49-1.32-7.01-7.01zm9.28 14.94 1.41-1.41-7.69-7.7-3.94-3.94-6.75-6.75-1.42 1.41 6.38 6.38L2 14v2l8.5-2.5V19L8 20.5V22l4-1 4 1v-1.5L13.5 19v-2.67l6.28 6.28z"/></svg>`
};
